export default {
    name: 'v5-icon-question',
    render: function (h) {
        return h('svg', {
            attrs: {
                class: 'icon',
                height: '32',
                viewBox: '0 0 1024 1024',
                width: '32',
                xmlns: 'http://www.w3.org/2000/svg'
            }
        }, [
            h('path', {
                attrs: {
                    d: 'M501.2 750.7c3.1 1.3 6.6 2.2 9.7 2.2 3.1 0 7.1-.9 9.7-2.2 12.8-5.3 18.6-19.9 12.8-32.8-2.2-5.8-7.1-10.2-12.8-12.8-3.1-1.3-6.6-2.2-9.7-2.2-3.1 0-7.1.9-9.7 2.2-6.2 2.7-10.6 7.5-13.3 13.3-2.7 6.2-2.7 13.3.4 18.6 2.7 6.6 7.2 11.4 12.9 13.7zm70-195.7c5.3-4.4 10.6-8.4 16.4-12.8l.4-.4c19.9-15.5 42.9-33.7 56.7-58 23.5-40.3 17.7-95.2-13.7-133.3-25.7-31.4-69.1-49.6-118.7-49.6-116.4 0-147.4 87.7-147.4 133.3 0 13.3 11.1 24.4 24.4 24.4 12-1.8 24.4-10.6 24.8-23.9 0-8.4 4-84.6 98.7-84.6 16.4 0 57.6 2.7 80.6 31 18.6 22.6 22.1 55.3 8.9 77.5-9.3 16.4-27 30.1-44.7 43.8l-.4.4c-5.3 4-12 8.9-17.7 13.7-32.8 27.4-51.8 70-51.8 113.8 0 13.3 11.1 24.4 24.4 24.4 13.3 0 24.4-11.1 24.4-24.4.1-28.8 12.5-56.7 34.7-75.3z',
                    fill: 'currentColor'
                }
            }),
            h('path', {
                attrs: {
                    d: 'M511.9 103.6c-226.1 0-409.3 183.3-409.3 409.3s183.3 409.3 409.3 409.3S921.3 739 921.3 512.9 738 103.6 511.9 103.6zm0 773.3c-201 0-364-163-364-364s163-364 364-364 364 163 364 364-162.9 364-364 364z',
                    fill: 'currentColor'
                }
            })
        ]);
    }
};
